import { render } from 'preact'
import { useState, useEffect } from 'preact/compat'
import React from 'react'

let wakeLock = null
const wakeLockSetting = window.MV_CREATE_SETTINGS.__OPTIONS__.wakeLockEnabled || false

const enableWakeLock = async () => {
    try {
        wakeLock = await navigator.wakeLock.request('screen')
        console.log('Wake Lock is active!')
      } catch (err) {
        // The Wake Lock request has failed - usually system related, such as battery.
        console.log(`${err.name}, ${err.message}`)
      }
}

export const HandsFree = (props) => {
    const { i, wakeLockSetting } = props
    //set state to Create's Hands Free Mode setting value
    const [handsFree, setHandsFree] = useState(!wakeLockSetting)

    useEffect(async () => {
        if (handsFree) {
            if (!wakeLock && !window.MV_CREATE_WAKELOCK) {
                window.MV_CREATE_WAKELOCK = true
                await enableWakeLock()
            }
        }
        else {
            if (wakeLock && window.MV_CREATE_WAKELOCK) {
                window.MV_CREATE_WAKELOCK = false
                wakeLock.release()
                    .then(() => {
                        wakeLock = null
                        console.log('Wake Lock is released!')
                    })
            }
        }
    }, [handsFree])

    const handleChange = () => {
        setHandsFree(!handsFree)
        const wakeLockCheckboxes = document.getElementsByClassName('hands-free-checkbox')
        //For the case of multiple cards on a page...
        //Since we can not wrap all of the wakeLock button components
        //in a containing component to use a state store, we need to
        //click all of the checkboxes so that the state matches up
        //on all of them and clicking any of them will either enable or 
        //disable the wakelock depending on the shared state.
        if (wakeLockCheckboxes.length > 1) {
            Array.from(wakeLockCheckboxes).forEach((el) => {
                
                if (el.checked !== !handsFree) {
                    el.click()
                }
                
            })
        }
    }
    return (
            <div className="handsfree-wrap">
                <div className="handsfree-text">
                    <p className="handsfree-large-text">
                        Hands Free Mode:
                    </p>
                    <p className="handsfree-small-text">
                        Prevent screen from sleeping
                    </p>
                </div>
                <label for={`handsfree-toggle${i}`} className="handsfree-toggle-button" data-testid={`handsfree-toggle${i}`}>
                    <span className={`handsfree-enabled ${handsFree}`}>On</span>
                    <span className={`handsfree-disabled ${handsFree}`}>Off</span>
                </label>
                <input
                    type="checkbox"
                    checked={handsFree}
                    onChange={handleChange}
                    id={`handsfree-toggle${i}`}
                    className="visually-hidden hands-free-checkbox"
                />

            </div>
    )
}

export default () => {
    const wakeLockCards = document.getElementsByClassName('mv-create-hands-free')
    //only render if we can find our element, the setting is enabled, and wakeLock is supported
    if (wakeLockSetting && wakeLockCards && 'wakeLock' in navigator) {
        Array.from(wakeLockCards).forEach((root, i) => {
            render(<HandsFree i={i} wakeLockSetting />, root)
        })
    }
}
